"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoPanelCms = void 0;
var PromoPanelCms = /** @class */ (function () {
    function PromoPanelCms() {
        this.acpStaticContentMsg = "You may be able to lower the monthly cost of your home internet or wireless service if you are eligible\n    for the federal government's Affordable Connectivity Program. Go to att.com/acp for details.";
        this.panelTitleLabel = 'Savings & promotions';
        this.removeApiErrTxt = "Uh-ho! Something went wrong. Try to remove the promo code again.\n     If the problem persist, please try again later.";
    }
    return PromoPanelCms;
}());
exports.PromoPanelCms = PromoPanelCms;
//# sourceMappingURL=promoPanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PromoPanel/promoPanel.cms.js
// module id = 1426
// module chunks = 8